import { render, staticRenderFns } from "./potential.vue?vue&type=template&id=bcb3ff5a&scoped=true"
import script from "./potential.vue?vue&type=script&lang=js"
export * from "./potential.vue?vue&type=script&lang=js"
import style0 from "./style/potential.scss?vue&type=style&index=0&id=bcb3ff5a&prod&lang=scss&scoped=true&external"
import style1 from "./potential.vue?vue&type=style&index=1&id=bcb3ff5a&prod&lang=scss&scoped=true"
import style2 from "./potential.vue?vue&type=style&index=2&id=bcb3ff5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb3ff5a",
  null
  
)

export default component.exports